import indexMixin from "../mixins/index";
export default {
  name: "res-progress",
  mixins: [indexMixin],

  data() {
    return {// 开启了showText以下才会起作用status、percentage、textInside、format
    };
  },

  computed: {
    obj() {
      // 直接绑定status为空时会报错
      let status = this.status;

      if (status) {
        return {
          status
        };
      }

      return {};
    }

  },
  props: {
    status: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "line"
    }
  }
};